<div class="fz-filter-section">
  <div class="fz-filter-section__header">
    <h4
      class="fz-filter-section__header__title mat-title-small font-color--tertiary"
    >
      {{ title() }}
    </h4>
  </div>
  <div class="fz-filter-section__content">
    <fz-chip-group>
      @for (item of visibleItems() || []; track item.key) {
        <fz-chip
          class="mb--1"
          [label]="item.label"
          [image]="item.image"
          @chipAnimation
          (click)="toggleItemSelection(item, item.selected)"
          [highlighted]="item.selected"
        >
        </fz-chip>
      }
    </fz-chip-group>
  </div>
  @if (items().length > limit() + limitIncrementStep) {
    <div class="fz-filter-section__show-more">
      <a (click)="showMore()" class="mat-label-medium mr--1">See more</a>
    </div>
  }
</div>
